import type { AutocompleteRefinementList } from '../types'

export const buildFacetFiltersFromRefinements = (
	refinementList: AutocompleteRefinementList
): string[] =>
	Object.entries(refinementList ?? {}).flatMap(
		([facetName, values]) =>
			values?.map((value) => `${facetName}:${value}`) ?? []
	)
